import { Label, ListGroup, ListGroupItem } from "reactstrap";
import { H5, H6, Image, LI, P } from "../../../../AbstractElements";
import { HoverFresherText1, MollyBoake } from "../../../../Constants/Constants";
import { dynamicImage } from "../../../../Utils";

const HoverFresherInterview = () => {
  return (
    <LI className="timeline-event">
      <Label className="timeline-event-icon" />
      <div className="timeline-event-wrapper">
        <P className="timeline-thumbnail">{"March 2025 - Fresher Interview"}</P>
        <H5 className="f-w-500">{HoverFresherText1}</H5>
        <div className="text-muted">
          {"A fresher's interview is to be conducted"}
          <ListGroup className="main-lists-content">
            <ListGroupItem action className="border-0 p-0 mb-4">
              <div className="d-flex w-100 justify-content-between align-items-center">
                <div className="list-wrapper">
                  <Image className="list-img img-fluid me-0 mb-0" src={dynamicImage(`user/1.jpg`)} alt="profile" />
                  <div className="list-content">
                    <H6>{MollyBoake}</H6>
                    <P>{"MollyBoake@rhyta.com"}</P>
                  </div>
                </div>
                <div className="timeline-icon">
                  <i className="icon-facebook"></i>
                  <i className="icon-google"> </i>
                  <i className="icon-twitter-alt"></i>
                </div>
              </div>
              <P className="mb-1">{"Next step is to choose a tone of voice for your content type."}</P>
            </ListGroupItem>
          </ListGroup>
        </div>
      </div>
    </LI>
  );
};
export default HoverFresherInterview;
